import { Component, ViewEncapsulation, HostListener, ElementRef, Input, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { LocationStrategy, Location, HashLocationStrategy, CommonModule } from '@angular/common';
import { NgxChartsModule, SingleSeries } from '@swimlane/ngx-charts';

import { ScaleType } from '../../common/types/scale-type.enum';
import { formatLabel, escapeLabel } from '../../common/label.helper';
import { LegendPosition } from '../../common/types/legend.model';
import { colorSets } from '../../utils/color-sets';

import { CanvasJSAngularChartsModule } from '@canvasjs/angular-charts';

import {
  truckAssign,
} from '../../data';

@Component({
  selector: 'app-truck-status',
  providers: [Location, { provide: LocationStrategy, useClass: HashLocationStrategy }],
  encapsulation: ViewEncapsulation.None,
  imports: [NgxChartsModule, CommonModule, CanvasJSAngularChartsModule],
  templateUrl: './truck-status.component.html',
  styleUrl: './truck-status.component.css'
})

export class TruckStatusComponent {
  @Input({ required: true }) frame!: [number, number]
  @Input({ required: true }) renderData!: SingleSeries
  chartViewFrame!: [number, number] // Default value
  chartWidth: string = '300px';
  chartHeight!: string;
  truckAssignData!: any[];
  colorScheme: any;
  colorSets: any;
  colorSchemeSM: any;
  schemeType = ScaleType.Ordinal;
  selectedColorScheme!: string;
  selectedColorSchemeSM!: string;
  animations: boolean = true;
  showLabel: boolean = false;
  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  legendTruckTitle = 'Truck Status';
  legendFuelCostTitle = 'Fuel Cost';
  xAxisLabelFuelCost = 'Month';
  yAxisLabelFuelCost = 'Fuel Cost';
  legendPosition = LegendPosition.Right;
  truckData: any[] = [
    { name: 'Truck 1', value: 1 },
    { name: 'Truck 2', value: 1 },
  ];


  // pie
  showLabels = true;
  explodeSlices = false;
  doughnut = false;
  arcWidth = 0.25;

  tooltipDisabled = false;

  chartOptions = {
    animationEnabled: true,
    theme: "red",
    title: {
      // text: "Truck Assign/Unassign",
      fontColor: "#777",
      fontFamily: "Arial, sans-serif",  // Set title font family
      fontSize: 24,
      fontWeight: 900
    },
    axisX: {
      labelFontColor: "white" // Set X-axis label text color to white
    },
    axisY: {
      labelFontColor: "white" // Set Y-axis label text color to white
    },
    toolTip: {
      fontColor: "black" // Set tooltip text color to white
    },
    data: [{
      type: "pie",
      indexLabelFontColor: "white",
      indexLabelFontFamily: "Arial, sans-serif",  // Set font family
      indexLabelFontSize: 16,  // Set font size
      startAngle: 45,
      indexLabel: "{name}: {y}",
      indexLabelPlacement: "inside",
      // yValueFormatString: "#,###.##'%'",
      dataPoints: [
        { label: "Assigned Truck", value: 2, color: "#7aa3e5" },
        { label: "Unassign Truck", value: 6, color: "#a8385d" }
      ].map(dp => ({
        name: dp.label,
        y: dp.value,  // Mapping custom 'value' to 'y'
        color: dp.color
      })),
      // dataPoints: [
      //   { y: 2, name: "Assigned Truck", color: "#7aa3e5" },
      //   { y: 6, name: "Unassign Truck", color: "#a8385d" }
      // ]
    }]
  }


  constructor(public location: Location, private el: ElementRef, private cdr: ChangeDetectorRef) {

    Object.assign(this, {
      colorSets,
      truckAssign
    });
    console.log("Data: ", this.renderData)


  }

  ngOnInit() {
    this.setColorScheme('cool');
    this.truckAssignData = this.renderData
    this.truckData = this.renderData
    console.log("Data is: ", this.truckAssignData)

    this.showLabel = true;
    this.updateTruckData(this.renderData)

  }

  updateTruckData(newData: any[]) {
    this.truckData = newData;
    // Manually trigger change detection to update the chart
    this.cdr.detectChanges();
  }


  customAssignTruckLabel(data: any): string {
    const totalTrucks: number = truckAssign.find(obj => obj.name === data)?.value ?? 0;
    return `${totalTrucks} ${totalTrucks > 1 ? 'Trucks' : 'Truck'}`;
  }


  ngAfterViewInit() {
    this.updateView();
  }

  @HostListener('window:resize')
  updateView() {
    const parentWidth = this.el.nativeElement.querySelector('.pie-column')?.clientWidth || 500;
    this.chartViewFrame = [parentWidth > 1500 ? parentWidth / 2 - 40 : parentWidth - 40, 300]; // Adjust the height as needed
    this.chartWidth = `${parentWidth > 1500 ? parentWidth / 2 - 40 : parentWidth - 40}px`;
    this.chartHeight = '300px';
  }

  setColorScheme(name: string) {
    this.selectedColorScheme = name;
    this.colorScheme = this.colorSets.find((s: { name: any; }) => s.name === name);
  }
  pieTooltipText({ data }: { data: { name: string; value: number } }) {
    const label = formatLabel(data.name);
    const val = formatLabel(data.value);

    return `
        <span class="tooltip-label">${escapeLabel(label)}</span>
        <span class="tooltip-val">${val}</span>
      `;
  }
  dblclick(event: any) {
    console.log('Double click', event);
  }
  select(data: any) {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
    console.log('Item data', this.truckAssignData);
    this.updateTruckData([
      { name: 'Truck Assigned', label: 'Truck Assigned', value: 1 },
      { name: 'Truck Unassigned', label: 'Truck Unassigned', value: 2 },
    ])
  }
  activate(data: any) {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  deactivate(data: any) {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }

}
